exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#calendar{padding:1.25rem}.fc-header-toolbar{margin:.625rem 1rem 1.5rem}.fc button{box-sizing:border-box;margin:0;height:2.6em!important;cursor:pointer}.fc-next-button,.fc-prev-button{min-width:10rem!important}.fc-prev-button{margin-right:1rem!important}.fc-event{background:#f7c44e;border:#f7c44e}.fc-today{background:#fef1c9}.fc-listMonth-button,.fc-month-button{padding:0 1.25rem!important}.fc-event-dot{background:#f7c44e}", ""]);

// exports
